__turbopack_context__.v({
  "guide_product": "GuideProduct-module-scss-module__ioACiq__guide_product",
  "guide_product_button": "GuideProduct-module-scss-module__ioACiq__guide_product_button",
  "guide_product_carousel": "GuideProduct-module-scss-module__ioACiq__guide_product_carousel",
  "guide_product_desc": "GuideProduct-module-scss-module__ioACiq__guide_product_desc",
  "guide_product_direction_row": "GuideProduct-module-scss-module__ioACiq__guide_product_direction_row",
  "guide_product_direction_row-reverse": "GuideProduct-module-scss-module__ioACiq__guide_product_direction_row-reverse",
  "guide_product_img_area": "GuideProduct-module-scss-module__ioACiq__guide_product_img_area",
  "guide_product_inner": "GuideProduct-module-scss-module__ioACiq__guide_product_inner",
  "guide_product_notice": "GuideProduct-module-scss-module__ioACiq__guide_product_notice",
  "guide_product_picture": "GuideProduct-module-scss-module__ioACiq__guide_product_picture",
  "guide_product_sub_title": "GuideProduct-module-scss-module__ioACiq__guide_product_sub_title",
  "guide_product_text_area": "GuideProduct-module-scss-module__ioACiq__guide_product_text_area",
  "guide_product_theme_primary": "GuideProduct-module-scss-module__ioACiq__guide_product_theme_primary",
  "guide_product_theme_secondary": "GuideProduct-module-scss-module__ioACiq__guide_product_theme_secondary",
  "guide_product_title": "GuideProduct-module-scss-module__ioACiq__guide_product_title",
});
